//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { expectationSubmit, getuuid } from '@/request/api'
import addImg from '@/images/add.png'
import deleteImg from '@/images/delete.png'
export default {
  name: 'questionnaire',
  data () {
    return {
      imgs: {
        addImg,
        deleteImg
      },
      name: '',
      department: '',
      jobNo: '',
      selected: '请选择',
      years: ['请选择', '2024年', '2025年', '2026年'],
      contents: [
        { content: '', year: '请选择' }
      ],
      isCanClick: true
    }
  },
  mounted () {
    document.title = '需求征集'

    const uuid = localStorage.getItem('uuid') || ''
    const params = { uuid }

    getuuid(params).then(res => {
      const { data: { uuid } } = res

      uuid && localStorage.setItem('uuid', uuid)
    })
  },
  methods: {
    addCell: function () {
      const obj = { content: '', year: '请选择' }
      let { contents } = this

      contents.push(obj)
      this.contents = [...contents]
    },

    deleteCell: function () {
      let { contents } = this

      contents.pop()
      this.contents = [...contents]
    },

    submit: function () {
      const { name, department, jobNo, contents, isCanClick } = this
      const isHasEmpty = contents.some(item => item.content === '')
      const isChoosedYear = contents.some(item => item.year === '请选择')

      if (!isCanClick) return

      this.isCanClick = false

      if (!name) {
        this.$notify({ type: 'warning', message: '请输入填写人姓名' })
        this.isCanClick = true

        return
      }

      if (!jobNo) {
        this.$notify({ type: 'warning', message: '请输入填写人工号' })
        this.isCanClick = true

        return
      }

      if (!department) {
        this.$notify({ type: 'warning', message: '请输入代表部门' })
        this.isCanClick = true

        return
      }

      if (isHasEmpty) {
        this.$notify({ type: 'warning', message: '请输入需求描述' })
        this.isCanClick = true

        return
      }

      if (isChoosedYear) {
        this.$notify({ type: 'warning', message: '请选择期望实现时间' })
        this.isCanClick = true

        return
      }

      contents.map(item => item.year = item.year.substring(0, 4))

      const params = {
        employee_id: jobNo,
        employee_name: name,
        department,
        contents: [...contents],
        uuid: localStorage.getItem('uuid') || ''
      }


      expectationSubmit(params).then(res => {
        if (res.code === 0) {
          this.$notify({ type: 'success', message: '提交成功！', duration: 2000 })
          setTimeout(() => {
            this.isCanClick = true
            this.$router.push('/questionnaire/success')
          }, 2000)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/questionnaire/index.vue